const BASE_URL = 'https://sendvigo-backend-production.up.railway.app';
export const apiFetch = async (endpoint, options = {}, token = null) => {
  const headers = {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` })
  };
  const response = await fetch(`${BASE_URL}${endpoint}`, { ...options, headers });
  const data = await response.json();
  if (!response.ok) {
    // Si la cuenta está suspendida, avisamos de forma centralizada (evento
    // global) para que la sesión se cierre automáticamente y se muestre el
    // mensaje real, sin depender de que cada pantalla lo maneje por su cuenta.
    if (data.code === 'ACCOUNT_SUSPENDED') {
      window.dispatchEvent(new CustomEvent('cuenta-suspendida', { detail: data.error }));
    }
    throw new Error(data.error || 'Error en la petición');
  }
  return data;
};